var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "h5",
        {
          staticClass:
            "card-header d-flex justify-content-between align-items-center",
        },
        [
          _c("div", { staticClass: "flex-grow-1" }, [
            _vm.id
              ? _c("span", [_vm._v("Редактировать")])
              : _c("span", [_vm._v("Добавить")]),
            _vm._v(" сегмент\n      "),
          ]),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-sm btn-secondary",
                "data-style": "zoom-in",
                loading: _vm.loading === "back",
              },
              on: {
                click: function ($event) {
                  return _vm.goBack()
                },
              },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-arrow-circle-o-left" }),
              _vm._v("Назад"),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", [_vm._v("Препарат:")]),
              _vm._v(" "),
              !_vm.id
                ? _c("drugSearch", { ref: "drugSearch" })
                : _c("h5", [_vm._v(_vm._s(_vm.drug.title))]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("div", [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group align-items-center" },
                  [
                    _c("datetime", {
                      attrs: {
                        id: "include_from",
                        "input-class": "form-control",
                        "value-zone": "UTC",
                        zone: "UTC",
                        type: "date",
                        format: "dd.MM.yyyy",
                        auto: true,
                      },
                      model: {
                        value: _vm.include_from,
                        callback: function ($$v) {
                          _vm.include_from = $$v
                        },
                        expression: "include_from",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" — ")]),
                    _vm._v(" "),
                    _c("datetime", {
                      attrs: {
                        id: "include_to",
                        "input-class": "form-control",
                        type: "date",
                        format: "dd.MM.yyyy",
                        auto: true,
                      },
                      model: {
                        value: _vm.include_to,
                        callback: function ($$v) {
                          _vm.include_to = $$v
                        },
                        expression: "include_to",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group align-items-center" },
                  [
                    _c("datetime", {
                      attrs: {
                        id: "exclude_from",
                        "input-class": "form-control",
                        type: "date",
                        format: "dd.MM.yyyy",
                        auto: true,
                      },
                      model: {
                        value: _vm.exclude_from,
                        callback: function ($$v) {
                          _vm.exclude_from = $$v
                        },
                        expression: "exclude_from",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(" — ")]),
                    _vm._v(" "),
                    _c("datetime", {
                      attrs: {
                        id: "exclude_to",
                        "input-class": "form-control",
                        type: "date",
                        format: "dd.MM.yyyy",
                        auto: true,
                      },
                      model: {
                        value: _vm.exclude_to,
                        callback: function ($$v) {
                          _vm.exclude_to = $$v
                        },
                        expression: "exclude_to",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group ml-5" }, [
              _c("label", [_vm._v("Текст sms:")]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.template,
                    expression: "template",
                  },
                ],
                staticClass: "form-control",
                staticStyle: {
                  width: "400px",
                  "max-width": "100%",
                  height: "120px",
                },
                attrs: { maxlength: "200" },
                domProps: { value: _vm.template },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.template = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "text-right" }, [
                _vm.template.length > 0
                  ? _c("small", [
                      _vm._v(_vm._s(_vm.template.length) + " симв."),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-success",
                "data-style": "zoom-in",
                loading: _vm.loading === "save",
              },
              on: {
                click: function ($event) {
                  return _vm.sendData()
                },
              },
            },
            [
              _c("i", { staticClass: "icon-fa icon-fa-save" }),
              _vm._v("Сохранить"),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticStyle: { color: "#209002" } }, [_vm._v("ДОБАВИТЬ")]),
      _vm._v(" клиентов из заказов, в период:"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", [
      _c("span", { staticStyle: { color: "#b10606" } }, [_vm._v("ИСКЛЮЧИТЬ")]),
      _vm._v(" клиентов из заказов, в период:"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }